const ru = {
  100000001:'Ключевая информация',
  100000002:'Название токена',
  100000003:'Создатель копии',
  100000004:'Время создания инстанса',
  100000005:'Основная информация',
  100000006:'Принадлежащая публичная цепочка/протокол',
  100000007:'Адрес смарт-контракта',
  100000008:'Дата выпуска',
  100000009:'Общая поставка',
  100000010:'Круговая поставка',
  100000011:'Рыночная стоимость',
  100000012:'Информация',
  100000013:'Информация в социальных сетях',
  100000014:'Веб-сайт',
  100000015:'Белая книга',
  100000016:'Браузер блокчейна',
  100000017:'Оценка проекта',
  100000018:'Рейтинг',
  100000019:'Топ ',
  100000020:'Code security',
  100000021:'Operation Performance',
  100000022:'Market Stability',
  100000023:'Governance Strength',
  100000024:'Project Health',
  100000025:'Community Trust',
  100000026:'Время обновлено',
  100000027:'Оценка безопасности',
  100000028:'Оценка безопасности контракта',
  100000029:'Статистика рисковых проектов',
  100000030:'Детали кода контракта',
  100000031:'Налог на покупку',
  100000032:'Налог на продажу',
  100000033:'Это ловушка?',
  100000034:'Можно ли повторно чеканить',
  100000035:'Есть ли черный список',
  100000036:'Есть ли белый список',
  100000037:'Есть ли защита от китов',
  100000038:'Можно ли изменить налоговую ставку',
  100000039:'Является ли это открытым исходным кодом',
  100000040:'Есть ли скрытые держатели',
  100000041:'Можно ли самоуничтожиться',
  100000042:'Является ли это прокси-контрактом',
  100000043:'Можно ли изменить баланс',
  100000044:'Можно ли выполнить внешний вызов',
  100000045:'Можно ли восстановить право собственности',
  100000046:'Существует ли период охлаждения для сделок',
  100000047:'Можно ли приостановить перевод',
  100000048:'Право собственности не отказано  ',
  100000049:'Является ли это регулируемым анти-китом  ',
  100000050:'Слишком много десятичных знаков  ',
  100000051:'Публичные методы Mint и Burn  ',
  100000052:'Обновляет ли сжигание токенов общий объём  ',
  100000053:'Обновляет ли сжигание токенов баланс  ',
  100000054:'Увеличивается ли баланс при самопереводе   ',
  100000055:'Будет ли недействительной транзакция на сумму',
  100000056:'Баланс не обновлён при переводе  ',
  100000057:'Будет ли потребляться баланс получателя  ',
  100000058:' Будет ли вызов TransferFrom неудачным',
  100000059:'Будет ли метод BurnFrom обновлять общее количество',
  100000060:'Определите налог на покупку токена. Выше 5% считается высокой налоговой ставкой',
  100000061:'Определите налог на продажу токена. Выше 5% считается высокой налоговой ставкой',
  100000062:'Проверьте, является ли токен мошенничеством с ловушкой (honeypot)',
  100000063:'Проверьте, можно ли выпустить больше токенов',
  100000064:'Проверьте, есть ли у токена черный список, который может ограничивать пользователей в обмене или переводе токенов',
  100000065:'Проверьте, есть ли у токена белый список, который позволяет адресам обходить любые ограничения',
  100000066:'Проверьте, есть ли у токена механизмы против крупных владельцев (анти-«кит»)',
  100000067:'Проверьте, есть ли у токена налог и может ли он быть изменен привилегированными ролями',
  100000068:'Проверьте, был ли токен проверен на блокчейн-обозревателе',
  100000069:'Проверьте, есть ли у токена скрытый владелец, который может манипулировать контрактом, даже если права собственности, кажется, были отреклись',
  100000070:'Проверьте, может ли токен самоуничтожиться',
  100000071:'Проверьте, является ли токен прокси-контрактом, который делегирует вызовы функций контракту-реализации',
  100000072:'Проверьте, может ли баланс токена быть изменен привилегированными ролями',
  100000073:'Проверьте, вызывает ли токен внешние контракты',
  100000074:'Проверьте, есть ли у токена лазейка для восстановления владения',
  100000075:'Проверьте, есть ли у токена механизм задержки передачи',
  100000076:'Проверьте, может ли торговля токеном быть приостановлена привилегированными ролями',
  100000077:'Проверьте, было ли отречено от привилегий владельца',
  100000078:'Проверьте, могут ли механизмы против крупных владельцев токена быть изменены привилегированными ролями',
  100000079:'Проверьте, больше или равно ли значение, возвращаемое функцией decimals(), 5',
  100000080:'Проверьте, будет ли откат при вызове функций mint() и burn() обычными пользователями',
  100000081:'Проверьте, будет ли корректно обновлено totalSupply при вызове функции burn()',
  100000082:"Проверьте, будет ли корректно обновлено разрешение при вызове функции burnFrom()",
  100000083:'Проверьте, увеличится ли баланс отправителя при вызове функции transfer() с получателем, который совпадает с отправителем транзакции',
  100000084:'Проверьте, завершится ли неудачей вызов функции transfer() с суммой, превышающей баланс',
  100000085:"Проверьте, обновляется ли разрешение тратящего соответственно после вызова функции transferFrom()",
  100000086:"Проверьте, будет ли использоваться баланс тратящего при вызове функции transferFrom()",
  100000087:"Проверьте, обновляется ли разрешение правильно после вызова transferFrom() или транзакция откатывается, если сумма недействительна.",
  100000088:"Проверьте, обновляется ли totalSupply правильно при вызове функции burnFrom()",
  100000089:'Проверьте, существует ли полномочие на выпуск токенов',
  100000090:'Проверьте, существует ли полномочие на заморозку',
  100000091:'Проверьте, можно ли изменить метаданные',
  100000092:'Критический',
  100000093:'Серьёзный',
  100000094:'Средний',
  100000095:'Незначительный',
  100000096:'Информационный',
  100000097:' Отказались ли от права чеканки',
  100000098:' Отказались ли от права заморозки',
  100000099:' Можно ли изменить метаданные токена',
  100000100:'',
  100000101:'',
  100000102:'',
  100000103:'',
  100000104:'',
  100000105:'',
}
export default ru


// WEBPACK FOOTER //
// ./src/i18n/langs/languageAllen/ru.js